import React from "react";
import "./index.css";
export default function NumberField(props) {
  return (
    <input
      title={props.value}
      style={props.style}
      type="number"
      value={props.value}
      name={props.name}
      disabled={props.disabled}
      className="number-field"
      onChange={e => props.onChange(e.target.name, e.target.value)}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/Costing/NumberField/index.js